import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import FPIcon from 'UI/components/atoms/FPIcon';

import { useStyles } from './SidebarActionButton.styled';

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {React.ElementType} props.icon
 * @param {number} props.iconSize
 * @param {function} props.onClick
 * @param {function} [props.onSetColor]
 * @param {string} props.text
 */
const SidebarActionButton = forwardRef(
  ({ className, icon, iconSize, onClick, onSetColor, text, ...rest }, ref) => {
    const { isSidebarOpen } = useSelector(({ app }) => app.ui);
    const classes = useStyles({ isSidebarOpen });

    return (
      <button
        type="button"
        ref={ref}
        onClick={onClick}
        className={clsx(classes.button, className)}
        aria-label={text}
        {...rest}
      >
        <FPIcon
          component={icon}
          size={iconSize}
          onSetColor={onSetColor || (() => 'currentColor')}
        />
        <span className={classes.label}>{text}</span>
      </button>
    );
  }
);

SidebarActionButton.displayName = 'SidebarActionButton';

export default SidebarActionButton;
